app.controller(
  'UserController', ['$scope', '$rootScope', 'Configuration', 'UserService' , UserController]
);

function UserController($scope, $rootScope, Configuration, UserService) {
    var vm = this;
    
    $rootScope.assetUrlImg = Configuration.assets.url + 'img/'; // assets url for img

    /**
     * [listPays in search]
     * @type {Array}
     */
    $scope.listUsers = ['User1', 'User2', 'User3'];

    $scope.mytest = 'Welcome to Louis Vuitton 2';
    vm.mytest = 'Local variables';

    $scope.$on(
      '$viewContentLoaded',
      function () {
          // dropdown();
          menu();
          //!  scrollAnchor();
          //tabs();
      });
    

    vm.user = null;
    vm.allUsers = [];
    vm.deleteUser = deleteUser;

    initController();

    function initController() {
        //loadCurrentUser();
        loadAllUsers();
        loadAllRoles();
        loadAllZones();
        loadRolesZones();
        loadAllLanguages();
    }

    function loadCurrentUser() {
        //UserService.GetByUsername($rootScope.globals.currentUser.username)
        UserService.GetByUsername('tpham')
            .then(function (user) {
                vm.user = user;
            });
    }

    function loadAllUsers() {        
        UserService.GetAll()
            .then(function (users) {
                vm.allUsers = users;
            });
    }    

    function deleteUser(id) {
        alert("Delete this user?");
        UserService.Delete(id)
        .then(function () {
            loadAllUsers();
        });
    }

    function loadAllRoles() {
        UserService.GetRoles()
            .then(function (roles) {
                vm.allRoles = roles;
            });
    }

    function loadRolesZones() {
        UserService.GetRolesZones()
            .then(function (rolesZones) {
                vm.allRolesZones = rolesZones;
            });
    }

    function loadAllZones() {
        UserService.GetZones()
            .then(function (zones) {
                vm.allZones = zones;
            });
    }

    function loadZone(id, lang) {
        UserService.GetZone(id, lang)
            .then(function (zone) {
                $scope.leftMenu = zone.rubricList;
            });
    }

    function loadAllLanguages() {
        UserService.GetAllLanguages()
            .then(function (languages) {
                vm.allAllLanguages = languages;
            });
    }

    vm.AddUserRoleZone = function () {
        console.log($rootScope.globals.currentUser.username + ":" + vm.activeRole + ":" + vm.activeZone);
        UserService.AddUserRoleZone($rootScope.globals.currentUser.username, vm.activeRole, vm.activeZone)
            .then(function (result) {
                console.log("Done");
                console.log(result);
                //if (response.success) {

                //}
                //else {
                //    //FlashService.Error(response.message);
                //}                
            });
    }
}
